import React from "react";

export default function TestimonialLiquid() {
  const testimonials = [
    {
      stars: 5,
      quote:
        "The Premium package with the 'Book Appointment' feature was a game-changer for my business. It made scheduling appointments a breeze for my clients.",
      name: "Charlotte Hale",
      title: "Director, Delos Inc.",
      avatar: "👩‍💼",
    },
    {
      stars: 5,
      quote:
        "I can't believe how effortless it was to get my landing page up and running with the Basic package. It saved me so much time and headache!",
      name: "Adam Cuppy",
      title: "Founder, EventsNYC",
      avatar: "👨‍💻",
    },
  ];

  return (
    <section className="section-liquid testimonials-section">
      <div className="container-liquid">
        <div style={{ textAlign: "center", marginBottom: "60px" }}>
          <span className="subheading-liquid">Testimonials</span>
          <h2
            className="heading-liquid"
            style={{
              fontSize: "clamp(2rem, 4vw, 3rem)",
              marginTop: "16px",
              marginBottom: "24px",
            }}
          >
            Our Clients{" "}
            <span
              style={{
                background: "var(--gradient-secondary)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                color: "#AF52DE", // Fallback color
              }}
            >
              Love Us.
            </span>
          </h2>
          <p
            className="text-liquid"
            style={{
              fontSize: "1.2rem",
              maxWidth: "600px",
              margin: "0 auto",
            }}
          >
            Discover What Our Clients Say: Read testimonials from satisfied
            customers.
          </p>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))",
            gap: "30px",
          }}
        >
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="glass-secondary liquid-float"
              style={{
                padding: "40px",
                textAlign: "center",
                animationDelay: `${index * 0.2}s`,
              }}
            >
              <div
                style={{
                  fontSize: "4rem",
                  marginBottom: "20px",
                }}
              >
                {testimonial.avatar}
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: "20px",
                  gap: "4px",
                }}
              >
                {[...Array(testimonial.stars)].map((_, i) => (
                  <span
                    key={i}
                    style={{ color: "#FFD700", fontSize: "1.5rem" }}
                  >
                    ⭐
                  </span>
                ))}
              </div>

              <p
                className="text-liquid"
                style={{
                  fontSize: "1.1rem",
                  fontStyle: "italic",
                  marginBottom: "24px",
                  lineHeight: "1.6",
                }}
              >
                "{testimonial.quote}"
              </p>

              <div>
                <h4
                  className="heading-liquid"
                  style={{
                    fontSize: "1.2rem",
                    marginBottom: "4px",
                  }}
                >
                  {testimonial.name}
                </h4>
                <p
                  className="text-liquid"
                  style={{
                    fontSize: "0.9rem",
                    opacity: 0.8,
                  }}
                >
                  {testimonial.title}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
